// @generated by protoc-gen-es v1.6.0 with parameter "target=ts"
// @generated from file dymensionxyz/dymension/eibc/authz.proto (package dymensionxyz.dymension.eibc, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Coin, DecProto } from "../../cosmos/base/v1beta1/coin_pb.js";

/**
 * FulfillOrderAuthorization allows the grantee to fulfill eIBC demand orders from the granter's account.
 *
 * @generated from message dymensionxyz.dymension.eibc.FulfillOrderAuthorization
 */
export class FulfillOrderAuthorization extends Message<FulfillOrderAuthorization> {
  /**
   * rollapps is an optional list of rollapp criteria that the grantee can fulfill demand orders from
   *
   * @generated from field: repeated dymensionxyz.dymension.eibc.RollappCriteria rollapps = 1;
   */
  rollapps: RollappCriteria[] = [];

  constructor(data?: PartialMessage<FulfillOrderAuthorization>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.eibc.FulfillOrderAuthorization";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rollapps", kind: "message", T: RollappCriteria, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FulfillOrderAuthorization {
    return new FulfillOrderAuthorization().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FulfillOrderAuthorization {
    return new FulfillOrderAuthorization().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FulfillOrderAuthorization {
    return new FulfillOrderAuthorization().fromJsonString(jsonString, options);
  }

  static equals(a: FulfillOrderAuthorization | PlainMessage<FulfillOrderAuthorization> | undefined, b: FulfillOrderAuthorization | PlainMessage<FulfillOrderAuthorization> | undefined): boolean {
    return proto3.util.equals(FulfillOrderAuthorization, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.eibc.RollappCriteria
 */
export class RollappCriteria extends Message<RollappCriteria> {
  /**
   * rollapp_id is the unique identifier of the rollapp that the grantee can fulfill demand orders from
   *
   * @generated from field: string rollapp_id = 1;
   */
  rollappId = "";

  /**
   * denoms is an optional list of denoms that the grantee can fulfill demand orders for
   *
   * @generated from field: repeated string denoms = 2;
   */
  denoms: string[] = [];

  /**
   * max_price is the optional maximum order price acceptable to the granter
   *
   * @generated from field: repeated cosmos.base.v1beta1.Coin max_price = 3;
   */
  maxPrice: Coin[] = [];

  /**
   * min_fee_percentage is the minimum gross fee earning percentage the LP is willing to get from a demand order
   *
   * @generated from field: cosmos.base.v1beta1.DecProto min_fee_percentage = 4;
   */
  minFeePercentage?: DecProto;

  /**
   * operator_fee_share is the share of the fee earnings willing to give to the operator
   *
   * @generated from field: cosmos.base.v1beta1.DecProto operator_fee_share = 5;
   */
  operatorFeeShare?: DecProto;

  /**
   * settlement_validated is the flag to only fulfill demand orders that have been settlement validated
   *
   * @generated from field: bool settlement_validated = 6;
   */
  settlementValidated = false;

  /**
   * spend_limit is the optional maximum amount of coins that can be spent by the grantee
   *
   * @generated from field: repeated cosmos.base.v1beta1.Coin spend_limit = 7;
   */
  spendLimit: Coin[] = [];

  constructor(data?: PartialMessage<RollappCriteria>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.eibc.RollappCriteria";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rollapp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "denoms", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "max_price", kind: "message", T: Coin, repeated: true },
    { no: 4, name: "min_fee_percentage", kind: "message", T: DecProto },
    { no: 5, name: "operator_fee_share", kind: "message", T: DecProto },
    { no: 6, name: "settlement_validated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "spend_limit", kind: "message", T: Coin, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RollappCriteria {
    return new RollappCriteria().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RollappCriteria {
    return new RollappCriteria().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RollappCriteria {
    return new RollappCriteria().fromJsonString(jsonString, options);
  }

  static equals(a: RollappCriteria | PlainMessage<RollappCriteria> | undefined, b: RollappCriteria | PlainMessage<RollappCriteria> | undefined): boolean {
    return proto3.util.equals(RollappCriteria, a, b);
  }
}

